

// import React from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaLinkedinIn,
//   FaInstagram,
//   FaArrowUp,
// } from "react-icons/fa";
// import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

// const container = {
//   hidden: {},
//   show: {
//     transition: {
//       staggerChildren: 0.15,
//     },
//   },
// };

// const block = {
//   hidden: { opacity: 0, y: 80, scale: 0.95 },
//   show: {
//     opacity: 1,
//     y: 0,
//     scale: 1,
//     transition: { duration: 0.9, ease: "easeOut" },
//   },
// };

// const listItem = {
//   hidden: { opacity: 0, x: -30 },
//   show: {
//     opacity: 1,
//     x: 0,
//     transition: { duration: 0.6, ease: "easeOut" },
//   },
// };

// const Footer = () => {
//   const currentYear = new Date().getFullYear();
//   const exploreLinks = [
//   { name: "Home", path: "/" },
//   { name: "About Us", path: "/about" },
//   { name: "Services", path: "/testimonials" },
//   { name: "Blogs", path: "/blogs" },
//   { name: "Contact", path: "/contact" },
//   // { name: "Our Work", path: "#" },
//   // { name: "Case Studies", path: "#" },
//   // { name: "Pricing", path: "#" },
// ];


//   return (
//     <footer className="relative bg-gradient-to-b from-[#050816] via-[#070B1A] to-black text-slate-300 pt-28 pb-12 overflow-hidden">
      
//       {/* Moving glow */}
//       <motion.div
//         animate={{ x: [0, 100, -100, 0], y: [0, -80, 80, 0] }}
//         transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
//         className="absolute top-[-150px] left-[-150px] w-[500px] h-[500px] bg-orange-500/10 blur-[160px]"
//       />
//       <motion.div
//         animate={{ x: [0, -120, 120, 0], y: [0, 90, -90, 0] }}
//         transition={{ duration: 22, repeat: Infinity, ease: "linear" }}
//         className="absolute bottom-[-150px] right-[-150px] w-[500px] h-[500px] bg-cyan-500/10 blur-[160px]"
//       />

//       <motion.div
//         variants={container}
//         initial="hidden"
//         whileInView="show"
//         viewport={{ once: true }}
//         className="relative max-w-7xl mx-auto px-6 lg:px-8"
//       >
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24">

//           {/* BRAND */}
//           <motion.div variants={block} className="space-y-7">
//             <Link to="/" className="flex items-center gap-4">
//               <motion.div
//                 whileHover={{ rotate: 10, scale: 1.15 }}
//                 className="w-16 h-16 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center text-white font-black text-2xl shadow-2xl"
//               >
//                 D
//               </motion.div>
//               <span className="text-2xl font-extrabold text-white">
//                 DIGITAL CANTO
//               </span>
//             </Link>

//             <p className="text-sm text-slate-400 leading-relaxed">
//              Turning clicks into clients! <br /> 
//               <span className="text-white font-medium">
//                 {" "}We craft strategies that boost your brand, drive leads, increase sales, and create lasting digital impact for your business.
//               </span>
//             </p>

//             <div className="flex gap-4">
//               {[ FaInstagram, FaFacebookF, FaTwitter, FaLinkedinIn].map(
//                 (Icon, i) => (
//                   <motion.a
//                     key={i}
//                     whileHover={{
//                       scale: 1.3,
//                       rotate: 8,
//                       boxShadow: "0px 0px 30px rgba(255,140,0,0.6)",
//                     }}
//                     className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 backdrop-blur flex items-center justify-center text-lg cursor-pointer"
//                   >
//                     <Icon />
//                   </motion.a>
//                 )
//               )}
//             </div>
//           </motion.div>

//           {/* EXPLORE – FULLY ANIMATED */}
//          {/* EXPLORE – CLEAN & PREMIUM */}
// <motion.div variants={block}>
//   <h4 className="text-white font-semibold mb-8 tracking-[0.25em] text-xs uppercase">
//     Explore
//   </h4>

//   <motion.ul
//     variants={container}
//     className="space-y-4 text-[13px]"
//   >
//     {exploreLinks.map((item) => (
//       <motion.li
//         key={item.name}
//         variants={listItem}
//         whileHover={{ x: 8 }}
//         className="group"
//       >
//         <Link
//           to={item.path}
//           className="flex items-center gap-3 text-slate-400 
//           transition-all duration-300 group-hover:text-[#F59E0B]"
//         >
//           {/* dot indicator */}
//           <span className="w-1.5 h-1.5 rounded-full bg-slate-600 
//           group-hover:bg-[#F59E0B] transition-all"></span>

//           {item.name}
//         </Link>
//       </motion.li>
//     ))}
//   </motion.ul>
// </motion.div>


//           {/* SERVICES – PRO MOTION */}
//           <motion.div variants={block}>
//             <h4 className="text-white font-bold mb-8 tracking-[0.3em] text-xs uppercase">
//               Services
//             </h4>
//             <motion.ul variants={container} className="space-y-5 text-sm">
//               {[
//                 "Web Design & Development",
//                 "Digital Marketing Solutions",
//                 "SEO & Search Optimization",
//                 "Brand Identity & Strategy",
//                 "Custom Software Development"
//               ].map((service) => (
//                 <motion.li
//                   key={service}
//                   variants={listItem}
//                   whileHover={{ scale: 1.08, x: 12 }}
//                   className="cursor-pointer text-slate-400 hover:text-orange-400 transition-all"
//                 >
//                   {service}
//                 </motion.li>
//               ))}
//             </motion.ul>
//           </motion.div>

//           {/* CONTACT */}
//           <motion.div
//             variants={block}
//             className="p-3 rounded-3xl bg-white/5 backdrop-blur-2xl border border-white/10 space-y-6 "
//           >
//             <h4 className="text-white font-bold tracking-[0.3em] text-xs uppercase">
//               Contact
//             </h4>
//             <div className="space-y-4 text-sm ">
//               <div className="flex gap-3 mt-10">
//                 <MdLocationOn className="text-orange-400 text-xl size-12" />
//                 Nikat Mata Mandir, Poonam Vihar,Khushalpur Moradabad, India
//               </div>
//               <div className="flex gap-3">
//                 <MdPhone className="text-orange-400 text-lg" />
//                 +91 8755250061 - 8273961025
//               </div>
//               <div className="flex gap-3">
//                 <MdEmail className="text-orange-400 text-lg" />
//                 digitalcantoinfo@gmail.com
//               </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* BOTTOM */}
//         <div className="border-t border-white/10 pt-10 flex justify-between items-center">
//           <p className="text-[10px] tracking-[0.4em] uppercase text-slate-500">
//             © {currentYear} DIGITAL CANTO | ALL RIGHT RESERVED
//           </p>

//           <motion.button
//             whileHover={{ y: -6 }}
//             onClick={() =>
//               window.scrollTo({ top: 0, behavior: "smooth" })
//             }
//             className="flex items-center gap-2 text-xs uppercase tracking-widest hover:text-orange-400"
//           >
//             Back to Top <FaArrowUp />
//           </motion.button>
//         </div>
//       </motion.div>
//     </footer>
//   );
// };

// export default Footer;











import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaArrowUp,
} from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";


/* animations */
const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.15 },
  },
};

const block = {
  hidden: { opacity: 0, y: 60 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const listItem = {
  hidden: { opacity: 0, x: -20 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.5 },
  },
};

/* FIXED social links */
const socialLinks = [
  { icon: FaInstagram, link: "https://www.instagram.com/digitalcanto/" },
  { icon: FaFacebookF, link: "https://www.facebook.com/profile.php?id=61574721231496" },
  { icon: FaTwitter, link: "https://x.com/DigitalCanto" },
  { icon: FaLinkedinIn, link: "https://www.linkedin.com/company/digitalcanto/" },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const exploreLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Testimonials", path: "/testimonials" },
    { name: "Blogs", path: "/blogs" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <footer className="relative bg-gradient-to-b from-[#050816] via-[#070B1A] to-black text-slate-300 pt-24 pb-10 overflow-hidden">

      {/* glow */}
      <div className="absolute -top-40 -left-40 w-[400px] h-[400px] bg-orange-500/10 blur-[150px]" />
      <div className="absolute -bottom-40 -right-40 w-[400px] h-[400px] bg-cyan-500/10 blur-[150px]" />

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="relative max-w-7xl mx-auto px-6"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 mb-20">

          {/* BRAND */}
          <motion.div variants={block} className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl overflow-hidden bg-white/10 border border-white/10">
                <img
                  src="./logo.png"
                  alt="Digital Canto Logo"
                  className="w-full h-full object-contain p-1 "
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">DIGITAL CANTO</h3>
                <p className="text-[10px] uppercase tracking-widest text-slate-400">
                  IT Services & Consultancy
                </p>
              </div>
            </Link>

            <p className="text-sm text-slate-400 leading-relaxed">
              Turning clicks into clients.  
              We help brands grow with smart marketing, powerful ads and
              conversion-focused strategies.
            </p>

            <div className="flex gap-4">
              {socialLinks.map(({ icon: Icon, link }, i) => (
                <motion.a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                   whileHover={{
                      scale: 1.3,
                      rotate: 8,
                      boxShadow: "0px 0px 30px rgba(255,140,0,0.6)",
                    }}
                  className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 
                             flex items-center justify-center text-lg 
                             hover:text-orange-400 transition"
                >
                  <Icon />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* EXPLORE */}
          <motion.div variants={block}>
            <h4 className="text-white font-semibold mb-6 tracking-widest text-xs uppercase">
              Explore
            </h4>
            <ul className="space-y-4 text-sm">
              {exploreLinks.map((item) => (
                <motion.li
                  key={item.name}
                  variants={listItem}
                  whileHover={{ x: 6 }}
                >
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-orange-400 transition"
                  >
                    {item.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* SERVICES */}
          <motion.div variants={block}>
            <h4 className="text-white font-semibold mb-6 tracking-widest text-xs uppercase">
              Services
            </h4>
            <ul className="space-y-4 text-sm">
              {[
                "Web Design & Development",
                "Digital Marketing Solutions",
                "SEO & Search Optimization",
                "Brand Identity & Strategy",
                "Custom Software Development"
              ].map((service) => (
                <motion.li
                  key={service}
                  variants={listItem}
                  className="text-slate-400 hover:text-orange-400 transition cursor-pointer"
                >
                  {service}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* CONTACT */}
        <motion.div
            variants={block}
            className="p-3 rounded-3xl bg-white/5 backdrop-blur-2xl border border-white/10 space-y-6 "
          >
            <h4 className="text-white font-bold tracking-[0.3em] text-xs uppercase">
              Contact
            </h4>
            <div className="space-y-4 text-sm ">
              <div className="flex gap-3 mt-10">
                <MdLocationOn className="text-orange-400 text-xl size-12" />
                Nikat Mata Mandir, Poonam Vihar,Khushalpur Moradabad, India
              </div>
              <div className="flex gap-3">
                <MdPhone className="text-orange-400 text-lg" />
                +91 8755250061 - 8273961025
              </div>
              <div className="flex gap-3">
                <MdEmail className="text-orange-400 text-lg" />
                digitalcantoinfo@gmail.com
              </div>
            </div>
          </motion.div>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-white/10 pt-8 flex justify-between items-center">
          <p className="text-[10px] tracking-widest text-slate-500 uppercase">
            © {currentYear} Digital Canto. All rights reserved
          </p>

          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 text-xs tracking-widest hover:text-orange-400 transition"
          >
            Back to top <FaArrowUp />
          </button>
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer;
